import { render, staticRenderFns } from "./aEllipseKpi.vue?vue&type=template&id=8b71d364&scoped=true"
import script from "./aEllipseKpi.vue?vue&type=script&lang=js"
export * from "./aEllipseKpi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b71d364",
  null
  
)

export default component.exports